import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "article-detail pa-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "float-right" }, "Artikelgruppe", -1)
const _hoisted_3 = { class: "float-right" }
const _hoisted_4 = {
  key: 0,
  class: "mt-n3"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "float-right" }, "Preiseinheit", -1)
const _hoisted_6 = { class: "float-right" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "float-right" }, "Inhalt", -1)
const _hoisted_9 = { class: "float-right" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "float-right" }, "Letzter Verkauf", -1)
const _hoisted_11 = { class: "float-right" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "px-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", {
  role: "separator",
  "aria-orientation": "horizontal",
  class: "v-divider theme--light"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", {
  role: "separator",
  "aria-orientation": "horizontal",
  class: "v-divider theme--light"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "float-right" }, "Kundengruppe", -1)
const _hoisted_17 = { class: "float-right" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" netto "),
  /*#__PURE__*/_createElementVNode("span", { class: "float-right" }, "brutto")
], -1)
const _hoisted_21 = { class: "float-right" }

import {ref, computed} from 'vue';
import Article from '@/model/Article';
import {findArticles, getArticle, getArticleStock} from '@/api/module/article';
import ArticleStock, {ApiArticleStock} from '@/model/ArticleStock';
import {useSettings} from '@/store/settings';
import moment from 'moment';
import ArticleStockItem from '@/components/Article/ArticleStockItem.vue';
import Subsidiary from '@/model/Subsidiary';
import {getSubsidiaries, getWarehouses} from '@/api/module/warehouse';
import router from '@/router';
import {useScanner} from '@/store/scanner';
import ErrorDisplay from '@/components/ErrorDisplay.vue';
import Loading from '@/components/Loading.vue';
import Warehouse from '@/model/Warehouse';
import {ArticlePrice} from '@/model/ArticlePrice';
import {useRoute} from 'vue-router';

type NiederlassungGruppe = {
  ArticleStockSummiert: ArticleStock;
  ArticleStocks: ArticleStock[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleDetail',
  setup(__props, { expose: __expose }) {


const route = useRoute();
const scanner = useScanner();
const settings = useSettings();
const selectedTab = ref<string>('info');
const article = ref<null | Article>(null);
const articleStock = ref<null | ArticleStock[]>(null);
const loading = ref(false);
const scanning = ref(false);
const error = ref<Error | null>(null);

const niederlassungen = ref<Subsidiary[]>([]);
const lagerhallen = ref<Warehouse[]>([]);


function loadNiederlassungen() {
  getSubsidiaries().then(([data]) => {
    niederlassungen.value = data;
  });
}

function loadLagerhallen() {
  getWarehouses({Niederlassung: settings.selectedSubsidiary ?? undefined}, []).then(([data]) => {
    lagerhallen.value = data;
  });
}

function getNiederlassungName(niederlassung: number): string {
  return niederlassungen.value.find((s) => s.NiederlassungNr == niederlassung)?.Name1 ?? '';
}

function getLagerhalleName(lagerhalle: number): string {
  return lagerhallen.value.find((s) => s.Lagerhalle == lagerhalle)?.Bezeichnung ?? '';
}

async function loadArticle() {
  if (article.value) return;
  loading.value = true;

  try {
    const [foundArticle] = await getArticle(route.params.id, {mitBeschreibung: true, mitArtikelPreise: true});
    if (!foundArticle) throw new Error('Artikel nicht gefunden');

    article.value = Article.fromApi(foundArticle);
  } catch (err: any) {
    console.log(err);
  } finally {
    loading.value = false;
  }
}

async function jumpToArticle(searchValue: string) {
  loading.value = true;
  try {
    const [foundArticles] = await findArticles(searchValue);

    const articles = foundArticles.map((a) => Article.fromApi(a));

    if (articles.length == 1) {
      if (article.value != null && articles[0].ArtikelNr == article.value.ArtikelNr) return;

      router.replace({name: 'article_info_detail', params: {id: `${articles[0].ArtikelNr}`}}).then(() => {
        console.log(route.params);
        refresh();
      }).catch(console.error);
    } else if (articles.length > 1) {
      router.push({name: 'article_info_list', query: {search: searchValue}}).catch(console.error);
    }
  } catch (err: any) {
    error.value = err as Error;
  } finally {
    loading.value = false;
  }
}

scanner.addScanListener(async (event) => {
  if (scanning.value) return;
  scanning.value = true;

  await jumpToArticle(event.data);

  scanning.value = false;
});

async function loadArticleStock() {
  if (articleStock.value) return;
  try {
    const [result] = await getArticleStock(route.params.id as string);

    articleStock.value = result.map((x) => ArticleStock.fromApi(x));
  } catch (err: any) {
    error.value = err as Error;
  }
}

const bestandAktuelleNiederlassungUndLagerhalle = computed((): ApiArticleStock | undefined => {
  if (!articleStock.value) return undefined;
  if (settings.selectedWarehouse == null) return undefined;

  const warehouse = settings.selectedWarehouse;

  return articleStock.value.find((s) => {
    return s.Niederlassung == warehouse.Niederlassung && s.Lagerhalle == warehouse.Lagerhalle;
  });
});

const bestandNiederlassungGruppiert = computed((): Map<number, NiederlassungGruppe> => {
  const result = new Map<number, NiederlassungGruppe>();
  if (!articleStock.value) return result;

  articleStock.value.forEach((x) => {
    const collection = result.get(x.Niederlassung);

    if (!collection) {
      result.set(x.Niederlassung, {
        ArticleStockSummiert: {
          MengeBestellt: x.MengeBestellt,
          MengeReserviert: x.MengeReserviert,
          BestandPhysikalisch: x.BestandPhysikalisch,
        } as ArticleStock,
        ArticleStocks: [x] as ArticleStock[],
      } as NiederlassungGruppe);
    } else {
      collection.ArticleStockSummiert.BestandPhysikalisch += x.BestandPhysikalisch;
      collection.ArticleStockSummiert.MengeReserviert += x.MengeReserviert;
      collection.ArticleStockSummiert.MengeBestellt += x.MengeBestellt;
      collection.ArticleStocks.push(x);
    }
  });

  return result;
});

const preistabellenGruppiert = computed((): Map<number, ArticlePrice[]> => {
  const result = new Map<number, ArticlePrice[]>();
  if (!article.value) return result;

  article.value.currentPrices.forEach((x) => {
    const collection = result.get(x.PreisTabelleNr);

    if (!collection) {
      result.set(x.PreisTabelleNr, [x]);
    } else {
      collection.push(x);
    }
  });

  return result;
});

function formatCurrency(val: number) {
  // eslint-disable-next-line no-irregular-whitespace
  return `${val.toFixed(2).replaceAll('.', ',')} €`;
}

function refresh() {
  article.value = null;
  articleStock.value = null;

  loadArticle();
  loadArticleStock();
}

loadNiederlassungen();
loadLagerhallen();
refresh();

__expose({
  selectedTab,
  article,
  articleStock,
  Loading,
  bestandAktuelleNiederlassungUndLagerhalle,
  bestandNiederlassungGruppiert,
  moment,
  ArticleStockItem,
  getNiederlassungName,
  getLagerhalleName,
  error,
  ErrorDisplay,
  formatCurrency,
  preistabellenGruppiert,
  loading,
});

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (error.value)
      ? (_openBlock(), _createBlock(ErrorDisplay, {
          key: 0,
          message: error.value.message,
          loading: loading.value,
          onRetry: _cache[0] || (_cache[0] = ($event: any) => (refresh()))
        }, null, 8, ["message", "loading"]))
      : _createCommentVNode("", true),
    (!loading.value && !error.value && article.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                title: article.value.Bezeichnung1,
                subtitle: article.value.Bezeichnung2
              }, null, 8, ["title", "subtitle"]),
              _createVNode(_component_v_list_item, {
                lines: "two",
                class: "mt-n3"
              }, {
                subtitle: _withCtx(() => [
                  _createTextVNode(" Artikel-Nr. "),
                  _hoisted_2
                ]),
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(article.value.ArtikelNr) + " ", 1),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(article.value.GruppeBezeichnung), 1)
                ]),
                _: 1
              }),
              (bestandAktuelleNiederlassungUndLagerhalle.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(ArticleStockItem, {
                      class: "mt-n3",
                      "article-stock": bestandAktuelleNiederlassungUndLagerhalle.value
                    }, null, 8, ["article-stock"])
                  ]))
                : _createCommentVNode("", true)
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_tabs, {
                modelValue: selectedTab.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedTab).value = $event)),
                "fixed-tabs": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tab, { "tab-value": "info" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Info")
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, { "tab-value": "bestand" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Bestand")
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, { "tab-value": "preise" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Preise")
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_window, {
                modelValue: selectedTab.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedTab).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, { value: "info" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { flat: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                lines: "two",
                                class: "mt-n3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Einheit "),
                                      _hoisted_5
                                    ], undefined, true),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(article.value.EinheitBezeichnungLang) + " (" + _toDisplayString(article.value.EinheitBezeichnung) + ") ", 1),
                                      _createElementVNode("span", _hoisted_6, _toDisplayString(article.value.PE1), 1)
                                    ], undefined, true),
                                    _: 1
                                  })
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, {
                                lines: "two",
                                class: "mt-n3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" EAN ")
                                    ], undefined, true),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(article.value.EANCode), 1)
                                    ], undefined, true),
                                    _: 1
                                  })
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, {
                                lines: "two",
                                class: "mt-n3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Beschreibung ")
                                    ], undefined, true),
                                    _: 1
                                  }),
                                  _createElementVNode("div", {
                                    innerHTML: article.value.getBeschreibung()
                                  }, null, 8, _hoisted_7)
                                ], undefined, true),
                                _: 1
                              }),
                              (article.value.HauptGebinde)
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 0,
                                    lines: "two",
                                    class: "mt-n3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_subtitle, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Haupt-Gebinde "),
                                          _hoisted_8
                                        ], undefined, true),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(article.value.HauptGebinde.GebindeBezeichnung) + " ", 1),
                                          _createElementVNode("span", _hoisted_9, _toDisplayString(article.value.HauptGebinde.GebindeInhalt) + " " + _toDisplayString(article.value.EinheitBezeichnungLang), 1)
                                        ], undefined, true),
                                        _: 1
                                      })
                                    ], undefined, true),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_list_item, {
                                lines: "two",
                                class: "mt-n3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Letzter Einkauf "),
                                      _hoisted_10
                                    ], undefined, true),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(moment)(article.value.LetztesEKDatum).format('DD.MM.YYYY')) + " ", 1),
                                      _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(moment)(article.value.LetztesVKDatum).format('DD.MM.YYYY')), 1)
                                    ], undefined, true),
                                    _: 1
                                  })
                                ], undefined, true),
                                _: 1
                              })
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "bestand" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { flat: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bestandNiederlassungGruppiert.value, ([niederlassung, niederlassungGruppiert]) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: niederlassung }, [
                                  _createVNode(_component_v_list_group, null, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_list_item, _mergeProps(props, {
                                        title: getNiederlassungName(niederlassung),
                                        subtitle: "Niederlassung",
                                        "append-icon": ""
                                      }), {
                                        default: _withCtx(() => [
                                          _createVNode(ArticleStockItem, {
                                            "article-stock": niederlassungGruppiert.ArticleStockSummiert
                                          }, null, 8, ["article-stock"]),
                                          _createElementVNode("div", _hoisted_12, [
                                            _createVNode(_component_v_icon, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("$expand")
                                              ], undefined, true),
                                              _: 1
                                            })
                                          ])
                                        ], undefined, true),
                                        _: 2
                                      }, 1040, ["title"])
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(niederlassungGruppiert.ArticleStocks, (articleStock) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: `${niederlassung}_${articleStock.Lagerhalle}`,
                                          class: "bg-grey-lighten-2"
                                        }, [
                                          _createVNode(_component_v_list_item, { class: "mb-3" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Lagerhalle")
                                                ], undefined, true),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(getLagerhalleName(articleStock.Lagerhalle)), 1)
                                                ], undefined, true),
                                                _: 2
                                              }, 1024)
                                            ], undefined, true),
                                            _: 2
                                          }, 1024),
                                          _createElementVNode("div", _hoisted_13, [
                                            _createVNode(ArticleStockItem, { "article-stock": articleStock }, null, 8, ["article-stock"])
                                          ]),
                                          _hoisted_14
                                        ]))
                                      }), 128))
                                    ], undefined, true),
                                    _: 2
                                  }, 1024),
                                  _hoisted_15
                                ], 64))
                              }), 128))
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "preise" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { flat: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preistabellenGruppiert.value, ([preistabelleNr, preise]) => {
                                return (_openBlock(), _createBlock(_component_v_list_group, {
                                  key: preistabelleNr,
                                  "active-color": ""
                                }, {
                                  activator: _withCtx(({ isOpen, props }) => [
                                    _createVNode(_component_v_list_item, _mergeProps(props, {
                                      title: `Preistabelle ${preistabelleNr}`,
                                      class: isOpen ? 'bg-grey-lighten-2' : ''
                                    }), {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Preistabelle " + _toDisplayString(preistabelleNr), 1)
                                          ], undefined, true),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_list_item_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Gültig "),
                                            _hoisted_16
                                          ], undefined, true),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(preise[0].dateString) + " ", 1),
                                            _createElementVNode("span", _hoisted_17, _toDisplayString(preise[0].KundenGruppe), 1)
                                          ], undefined, true),
                                          _: 2
                                        }, 1024),
                                        _createElementVNode("div", _hoisted_18, [
                                          _createVNode(_component_v_icon, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode("$expand")
                                            ], undefined, true),
                                            _: 1
                                          })
                                        ])
                                      ], undefined, true),
                                      _: 2
                                    }, 1040, ["title", "class"])
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preise, (price) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "bg-grey-lighten-2",
                                        key: price.key
                                      }, [
                                        _createVNode(_component_v_list_item, { lines: "two" }, {
                                          subtitle: _withCtx(() => [
                                            (price.qtyString)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(price.qtyString) + " " + _toDisplayString(article.value.EinheitBezeichnung), 1))
                                              : _createCommentVNode("", true),
                                            _hoisted_20
                                          ]),
                                          title: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(formatCurrency(price.Netto)) + " ", 1),
                                            _createElementVNode("span", _hoisted_21, _toDisplayString(formatCurrency(price.Brutto)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (_openBlock(), _createElementBlock("hr", {
                                          role: "separator",
                                          key: `${price.PreisTabelleNr}-${price.AbMenge}-hr`,
                                          "aria-orientation": "horizontal",
                                          class: "v-divider theme--light"
                                        }))
                                      ]))
                                    }), 128))
                                  ], undefined, true),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          })
        ], 64))
      : (_openBlock(), _createBlock(Loading, { key: 2 }))
  ]))
}
}

})